function includes(array = [], item) {
  return array.some(arrayItem => arrayItem === item);
}

export function includesObject(array = [], item) {
  return array.some(arrayItem => arrayItem.id === item.id)
}

export default includes
